export enum FooterTheme {
  default = 'default',
  white = 'white',
}
